module.exports = __webpack_public_path__ + "static/media/remove-button.2310b2e0.svg";